module.exports = __webpack_public_path__ + "static/img/style2.b69e5ae7.png";